import { createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  originalImages: [],
  images: [],
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setHomeImages(state, action) {
      const { images, authenticated } = action.payload;
      state.images = images;
      if (!authenticated) {
        state.originalImages = images;
      }
    },
    cleanHomeSlice(state) {
      const { originalImages } = current(state);
      state.images = [...originalImages];
    },
  },
});

export const { cleanHomeSlice, setHomeImages } = homeSlice.actions;

export default homeSlice.reducer;
